import { Utils } from './utils';
var TokenRequestRecord = /** @class */ (function () {
    function TokenRequestRecord() {
    }
    return TokenRequestRecord;
}());
var TokenCache = /** @class */ (function () {
    function TokenCache(tokenExpirationMs /* 55 minutes */) {
        if (tokenExpirationMs === void 0) { tokenExpirationMs = 55 * 60 * 1000; }
        // Map from token request key to token
        this.tokenCache = new Map();
        // Map from token request key to token request (for compatibility with Maps in ChakraCore)
        this.requestMap = new Map();
        // Map from token request key to token request record (for tracking pending requests)
        this.requestRecordMap = new Map();
        this.tokenExpirationMs = tokenExpirationMs;
    }
    /**
     * Request a token from the host for the given tokenRequest if we have no token or the token expired
     * and update the token cache accordingly. Does not instantaneously update the token but subsequent
     * requests will resolve the same promise.
     */
    TokenCache.prototype.updateAuthToken = function (hostCallbacks, tokenRequest) {
        var _this = this;
        var requestKey = JSON.stringify(tokenRequest);
        var tokenRequestRecord = this.requestRecordMap.get(requestKey);
        if (tokenRequestRecord === undefined || this.isTokenExpired(tokenRequestRecord)) {
            tokenRequestRecord = {
                requestPromise: hostCallbacks
                    .requestAuthToken(tokenRequest)
                    .then(function (response) {
                    if (!response || !response.Token) {
                        throw new Error("No token available for request ".concat(requestKey));
                    }
                    _this.tokenCache.set(requestKey, response.Token);
                }),
                requestTime: Utils.getCurrentTimeMs()
            };
            this.requestRecordMap.set(requestKey, tokenRequestRecord);
        }
        return tokenRequestRecord.requestPromise;
    };
    /**
     * Get all tokens (and tickets) in the cache and update expired tokens
     */
    TokenCache.prototype.getAuthTokenEntries = function (hostCallbacks, docId) {
        var _this = this;
        return Array.from(this.tokenCache.keys())
            .map(function (requestKey) {
            // Get the auth token request or parse it from the key
            var request = _this.requestMap.get(requestKey);
            if (request === undefined) {
                request = JSON.parse(requestKey);
                _this.requestMap.set(requestKey, request);
            }
            return { requestKey: requestKey, request: request };
        })
            .filter(function (_a) {
            var request = _a.request;
            // Get requests matching the given docId
            return docId ? request.DocId === docId : true;
        })
            .map(function (_a) {
            var requestKey = _a.requestKey, request = _a.request;
            if (_this.isTokenExpired(_this.requestRecordMap.get(requestKey))) {
                // NOTE: Does not update the token immediately for this request
                _this.updateAuthToken(hostCallbacks, request);
            }
            return {
                ticket: request.Tickets[0],
                token: _this.tokenCache.get(requestKey)
            };
        });
    };
    TokenCache.prototype.isTokenExpired = function (tokenRequestRecord) {
        return Utils.getCurrentTimeMs() > tokenRequestRecord.requestTime + this.tokenExpirationMs;
    };
    return TokenCache;
}());
export { TokenCache };
//# sourceMappingURL=token-cache.js.map